import React from "react";

// SVG flags — emoji flags don't render on Windows, so we draw them.
export const Flag = ({ code, size = 22 }) => {
  const w = Math.round((size * 4) / 3);
  const common = {
    width: w,
    height: size,
    viewBox: "0 0 60 45",
    style: { borderRadius: 3, display: "block", boxShadow: "0 0 0 1px rgba(0,0,0,0.08)" },
    "aria-hidden": true,
  };
  switch (code) {
    case "fr":
      return (
        <svg {...common}>
          <rect width="20" height="45" fill="#0055A4" />
          <rect x="20" width="20" height="45" fill="#FFFFFF" />
          <rect x="40" width="20" height="45" fill="#EF4135" />
        </svg>
      );
    case "en":
      return (
        <svg {...common}>
          <rect width="60" height="45" fill="#012169" />
          <path d="M0,0 L60,45 M60,0 L0,45" stroke="#FFFFFF" strokeWidth="9" />
          <path d="M0,0 L60,45 M60,0 L0,45" stroke="#C8102E" strokeWidth="4" />
          <path d="M30,0 V45 M0,22.5 H60" stroke="#FFFFFF" strokeWidth="15" />
          <path d="M30,0 V45 M0,22.5 H60" stroke="#C8102E" strokeWidth="9" />
        </svg>
      );
    case "es":
      return (
        <svg {...common}>
          <rect width="60" height="45" fill="#AA151B" />
          <rect y="11.25" width="60" height="22.5" fill="#F1BF00" />
        </svg>
      );
    case "pt":
      return (
        <svg {...common}>
          <rect width="60" height="45" fill="#DA291C" />
          <rect width="24" height="45" fill="#046A38" />
          <circle cx="24" cy="22.5" r="8" fill="#FFE900" stroke="#DA291C" strokeWidth="1.5" />
        </svg>
      );
    default:
      return null;
  }
};

export default Flag;
